import { render, staticRenderFns } from "./ctrlobs3Motivos.vue?vue&type=template&id=fb2477f8"
import script from "./ctrlobs3Motivos.vue?vue&type=script&lang=js"
export * from "./ctrlobs3Motivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports